import { ENDPOINTS } from "utils/endpoints";
import {
  DELETE_API_CALL,
  GET_API_CALL,
  PATCH_API_CALL,
  POST_API_CALL,
} from "utils/services";
import { APIResponseModal, ReducersModal } from "utils/modals";
import { createQueryParams } from "utils/constants";
import { CAR_COMPANY_REDUCER } from "store/actionTypes";
import { mapPaginatedResult, mapVehicleListItem } from "utils/apiMappers";

export const getVehicleList = (callback: any, params: any = {}) => {
  return (dispatch: Function, getState: Function) => {
    const store: ReducersModal = getState();
    const carCompanies = store.CarCompanyReducer;
    // const {
    //   carCompanies: {
    //     // sortOrder,
    //     // sortedBy,
    //     // pagination: { limit, page },
    //     result:originalList2
    //   },
    // } = carCompanies;

    const vehicles = store.CarCompanyReducer;
    const {
      vehicles: {
        result: originalList,
        sortOrder,
        sortedBy,
        search: storedSearch,
        pagination: { limit, page }
      }
    } = vehicles;

    const name = `${params.name ?? params.search ?? storedSearch ?? ""}`.trim();

    dispatch({
      type: CAR_COMPANY_REDUCER,
      payload: {
        vehicles: {
          ...carCompanies.vehicles,
          isLoading: true,
          search: name,
        },
      },
    });

    const query = createQueryParams({
      page,
      limit,
      sortedBy,
      sortOrder,
      ...(name ? { name: encodeURIComponent(name) } : {}),
    });
        GET_API_CALL(
      ENDPOINTS.VEHICLE.VEHICLE_LIST + "?",
      query,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const dataToSave = mapPaginatedResult(
            response.data,
            mapVehicleListItem
          );

                              if (page > 1) {
            dataToSave.result = [...originalList, ...dataToSave.result];
          }

          dispatch({
            type: CAR_COMPANY_REDUCER,
            payload: {
              vehicles: {
                ...carCompanies.vehicles,
                ...dataToSave,
                search: name,
                isLoading: false,
              },
            },
          });
          callback(dataToSave.result);
        } else {
          dispatch({
            type: CAR_COMPANY_REDUCER,
            payload: {
              vehicles: {
                ...carCompanies.vehicles,
                isLoading: false,
              },
            },
          });
        }
      }
    );
  };
};

export const fetchVehicleNameList = (
  params: any = {},
  callback: Function = () => { }
) => {
  return () => {
    const name = `${params.name || params.search || ""}`.trim();
    const query = createQueryParams({
      page: params.page || 1,
      limit: params.limit || 100,
      ...(name ? { name: encodeURIComponent(name) } : {}),
    });
        GET_API_CALL(
      ENDPOINTS.VEHICLE.VEHICLE_LIST + "?",
      query,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const { result } = mapPaginatedResult(
            response.data,
            mapVehicleListItem
          );
                    callback(Array.isArray(result) ? result : []);
        } else {
          callback([]);
        }
      }
    );
  };
};

export const addNewVehicle = (params: any) => {
  return (dispatch: Function, getState: Function) => {
    POST_API_CALL(
      ENDPOINTS.VEHICLE.ADD_NEW_VEHICLE,
      params.data,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          dispatch(getVehicleList(() => {}));
          params.callback(response?.data?.result);
        } else {
          params.callback();
        }
      }
    );
  };
};

export const updateVehicle = (params: any) => {
  return (dispatch: Function) => {
    const { id, ...payload } = params.data || {};
    const url = `${ENDPOINTS.VEHICLE.UPDATE_VEHICLE}/${id}`;
        PATCH_API_CALL(url, payload, (response: APIResponseModal) => {
      if (response.isSuccess && response.data) {
        dispatch(getVehicleList(() => {}));
        params.callback(response?.data?.result);
      } else {
        params.callback();
      }
    });
  };
};

export const deleteVechile = (params: any) => {
  return (dispatch: Function, getState: Function) => {
    DELETE_API_CALL(
      ENDPOINTS.VEHICLE.DELETE_VEHICLE + "/" + params.data.id,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          dispatch(getVehicleList(params.callback));
          params.callback(response?.data?.result);
        } else {
          params.callback();
        }
      }
    );
  };
};
